import { cn } from '~/common/utils/styleUtil';
import { Registration } from '~/shell/components/Registration';
import { ClientOnly } from 'remix-utils/client-only';
import { useScreenSize } from '~/common/hooks/useScreenSize';
import { useMemo } from 'react';
import { useHasTopBanner } from '~/shell/hooks/useHasTopBanner';
import { BREAKPOINTS } from '~/common/components/context/ScreenSizeContext.tsx';

export interface SidebarContentProps {
  isAuthenticated: boolean;
}

export function SidebarContent({ isAuthenticated }: Readonly<SidebarContentProps>) {
  const { hasTopBanner } = useHasTopBanner();
  const { screenSize, is2XlDown, isDesktop } = useScreenSize();

  const right = useMemo(() => {
    if (is2XlDown) {
      return 32;
    }

    return (screenSize.width - BREAKPOINTS.XXL) / 2 + 32;
  }, [screenSize, is2XlDown]);

  return (
    <ClientOnly>
      {() => (
        <div
          className={cn('xl:fixed xl:top-[148px] xl:w-[260px]', hasTopBanner && 'xl:top-[188px]')}
          style={{
            right: isDesktop ? right : 'auto'
          }}
        >
          {!isAuthenticated && <Registration />}
        </div>
      )}
    </ClientOnly>
  );
}
